import axios from 'axios';

// Idea taken from https://alligator.io/react/axios-react/
const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL,
});

export default API;
